let id_counter = 1;
export default class Cell {
    id: number;
    value: number;
    is_selected = false;
    is_solved = false;

    constructor(value: number) {
        this.value = value
        this.id = id_counter++

        if(value === 0) {
            this.is_solved = true;
        }
    }
}